/**Conneccion con BD Firebase */
import { keyFirebaseP } from './stringConnection';
export const config = {
  apiKey: keyFirebaseP,
  authDomain: 'hupity-9b190.firebaseapp.com',
  databaseURL: 'https://hupity-9b190.firebaseio.com',
  projectId: 'hupity-9b190',
  storageBucket: 'hupity-9b190.appspot.com',
  messagingSenderId: '874067485777'
}
///firebase desarrollo
/*
export const config = {
    apiKey: keyFirebaseD,
    authDomain: "pruebahuper.firebaseapp.com",
    databaseURL: "https://pruebahuper.firebaseio.com",
    projectId: "pruebahuper",
    storageBucket: "pruebahuper.appspot.com",
    messagingSenderId: "328282757234"
  };

*/
//Visualizacion 
/*
  export const config = {
    apiKey: keyFirebaseV,
    authDomain: "hupity-visual.firebaseapp.com",
    databaseURL: "https://hupity-visual.firebaseio.com",
    projectId: "hupity-visual",
    storageBucket: "hupity-visual.appspot.com",
    messagingSenderId: "80713476876",
    appId: "1:80713476876:web:0116352d070bc423"
  };
*/
